import { FETCH_ARTWORKS_SEARCH_RESULTS } from "../../../../../graphql/query/Artwork";
import { artworkFilterStore } from "../../../components/useArtworkFilters";

const SearchedArtworks = props => {
  const tableProps = {
    dataKey: "artworksV2",
    FETCH_QUERY: FETCH_ARTWORKS_SEARCH_RESULTS,
    variables: {
      ...artworkFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedArtworks;
